// NoteDetail.js
import React, { useRef, useState, useEffect, useCallback } from 'react';
import './Notedetail.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCalendar, faClock, faPaperPlane, faStop  } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { set } from 'react-hook-form';
import { useUserAuth } from "../context/UserAuthContext";
import Draggable from 'react-draggable';
import ReactPlayer from 'react-player';
import Button from 'react-bootstrap/Button'
import nl2br from 'react-nl2br';
import { use } from 'react';
import e from 'cors';
import { GPT_PROMPT_CONTENT }  from './Keywords';


// 最大token限制（根据模型调整）
const MAX_TOKENS = 3500;
const AVG_TOKEN_PER_MSG = 120;
let flagOfTopic = false;

const Notedetail = ({ note, onClose, getGPTResponse, nvoiceLogo, userAvatar, upgradeUserLevel }) => {
  const [view, setView] = useState('summary'); // or 'transcript'
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [noteLocal, setNoteLocal] = useState(note);
  const [transcriptBody, setTranscriptBody] = useState(null);
  const [noteDetailChanged, setNoteDetailChanged] = useState(false);
  const [messageChanged, setMessageChanged] = useState(false);
  const [inputWidth, setInputWidth] = useState('auto'); 
  const noteHeaderRef = useRef(null);
  const [formattedPolishedText, setFormattedPolishedText] = useState('');
  const [formattedTranscript, setFormattedTranscript] = useState('');
  const [formattedSummary, setFormattedSummary] = useState('');
  const [formattedGptresponse, setFormattedGptresponse] = useState('');
  const [formattedTitle, setFormattedTitle] = useState('');
  const [formattedKeywords, setFormattedKeywords] = useState('');
  const [formattedOutline, setFormattedOutline] = useState('');
  const textareaRefOFPolishedText = useRef(null);
  const textareaRefOFTranscript = useRef(null);
  const textareaRefOFSummary = useRef(null);
  const [noteID, setNoteID] = useState('');
  const [audioUrl, setAudioUrl] = useState('');
  const [videoID, setVideoID] = useState('');
  const [videoURL, setVideoURL] = useState('');
  const { user, fetchTrascriptionData, updateTranscriptionData, transcriptDataBuffer, getVideoData, userDataLocal, updateVideoData, checkToken, userVipLevel, setCurrentUpdateReason, setNeedUpdate } = useUserAuth();
  const [transcriptDataExist, setTranscriptDataExist] = useState(false);
  const [showHint, setShowHint] = useState(true);
  const [showPlayer, setShowPlayer] = useState(true);

  const [activeTab, setActiveTab] = useState('AI Chat');
  const [userName, setUserName] = useState('You');
  const [messages, setMessages] = useState([]);
  // 用于自动滚动到底部的引用
  const messagesEndRef = useRef(null);

  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isStreaming, setIsStreaming] = useState(false);
  const [content, setContent] = useState('');
  const [streamingContent, setStreamingContent] = useState(''); // 用于显示流式请求中的内容

  const [tokenUsage, setTokenUsage] = useState(0);

  const inputRef = useRef(null);

  const defaultPrompt = `
    IMPORTANT INSTRUCTIONS FOR HANDLING REFERENCE CONTENT AND USER QUESTIONS:

      1. The reference content contains timestamps in this format: 'Time: [00:10:03] - [00:10:57] Text content for this period'

      2. When answering questions about the content:
        - ALWAYS identify and reference the specific timestamps where important information appears
        - Use the exact timestamp format: HH:MM:SS followed by the content summary
        - Do NOT invent or estimate timestamps - only use timestamps that actually exist in the content

      3. For questions asking about key moments, important points, or timestamps:
        - Extract ALL relevant timestamps and their corresponding content
        - Format each point as: HH:MM:SS Brief description of what happens at this timestamp
        - Organize chronologically for better readability

      4. Example proper response format:
        00:01:23 Speaker introduces the main topic of discussion
        00:05:47 First key argument about market trends is presented
        00:12:30 Counterpoint regarding investment strategy is discussed

      5. If mathematical formulas appear in your response, write them directly without escape characters.

      6. Remember to actively search for and include all relevant timestamps when analyzing the content.

      7. IMPORTANT: If the user's question clearly does not require a timestamp or not explicitly mention time-related issues, please do not include any timestamp or time information. In all other cases, follow the above instructions.`;

      //Remember to actively search for and include all relevant timestamps when analyzing the content.`

  const defaultUserPrompt = `
    IMPORTANT INSTRUCTIONS FOR HANDLING REFERENCE CONTENT AND USER QUESTIONS:

      1. The reference content contains timestamps in this format: 'Time: [00:10:03] - [00:10:57] Text content for this period'

      2. When answering questions about the content:
        - ALWAYS identify and reference the specific timestamps where important information appears
        - Use the exact timestamp format: HH:MM:SS followed by the content summary
        - Do NOT invent or estimate timestamps - only use timestamps that actually exist in the content

      3. For questions asking about key moments, important points, or timestamps:
        - Extract ALL relevant timestamps and their corresponding content
        - Format each point as: HH:MM:SS Brief description of what happens at this timestamp
        - Organize chronologically for better readability

      4. Example proper response format:
        00:01:23 Speaker introduces the main topic of discussion
        00:05:47 First key argument about market trends is presented
        00:12:30 Counterpoint regarding investment strategy is discussed

      5. If mathematical formulas appear in your response, write them directly without escape characters.

      6. Remember to actively search for and include all relevant timestamps when analyzing the content.

      7. IMPORTANT: If the user's question clearly does not require a timestamp or not explicitly mention time-related issues, there is no need to include a timestamp in the answer, just summarize the reference content above; if the user's question explicitly includes time-related items, you need to summarize 20 important nodes with timestamps for the reference content.
        - For example, if the user asks "What are the key points in the video?", you can summarize the content without timestamps.
        - If the user asks "What are the key points in the video? Please summarize with timestamps.", you need to summarize 20 important nodes with timestamps for the reference content.`;

  const defaultUserQuestion = 
  `Please output the important topics of the video at one time based on the transcription of the long video above. Requirements:

  1. Number them in order of appearance.

  2. Summary rules for important topics: For content longer than 10 minutes, summarize one important topic every 10 minutes; for content shorter than 10 minutes, summarize up to 5 important topics.

  3. Summary rule 1 for subsections: Give each important topic a concise title (no timestamp required for the title), and divide it into several subsections under the title. The number of subsections under each important topic should not exceed 3.

  4. Summary rule 2 for subsections: Give each subsection a subtitle and a brief description, and add a start timestamp in front of the subsection (just the start time point, no extra timestamps).

  4. Output the complete result directly in the end, do not list the topics first and then answer them in two steps.

  5. Please reply to all content in the same language as the transcription of the video.

  Output example:

  1. Title A
  00:00:28 - Infrastructure construction and international image: ...
  00:01:48 - Labor problems in the west: ...

  2. Title B
  00:03:13 - Challenges of overcapacity: ...
  00:06:42 - Economic belts on the sea and land: ...

  ...`;

  // Ref存储优化用状态
  const contextRef = useRef({
    lastContentHash: '',
    systemPrompt: '',
    shortMemory: [],
    controller: null,
    summaryOfChat: '' 
  });

  //2025.05.09
  const [defaultPromptContent, setDefaultPromptContent] = useState('Ask Nvoice sth. e.x: Summarize the timestamps');

  // 简单哈希生成函数
  const generateContentHash = (content) => {
    return content.split('').reduce((a,b) => (((a << 5) - a) + b.charCodeAt(0))|0, 0);
  };
  
  useEffect(() => {
    setFormattedPolishedText(formatAndDisplayText(note.polishedText || ''))
    preSetTranscript(formatAndDisplayText(note.transcript || ''))
    setFormattedSummary(formatAndDisplayText(note.summary || ''))
    setFormattedGptresponse(formatAndDisplayText(note.gptresponse || ''))
    let title = note.title || '';
    setFormattedTitle(title.replace(/"/g, ''))
    setFormattedKeywords(note.keywords || '')
    setFormattedOutline(formatAndDisplayText(note.outline || ''))
    setNoteID(note.noteID);
    preSetUserName();

    let textarea = textareaRefOFSummary.current;
    const onScroll = () => {
      if (textareaRefOFTranscript.current) {
        textarea = textareaRefOFTranscript.current;
      } else if(textareaRefOFSummary.current) {
        textarea = textareaRefOFSummary.current;
      }
      textarea.style.height = 'auto';
      textarea.style.height = (textarea.scrollHeight) + 'px';
    };
    onScroll();
    textarea.addEventListener('scroll', onScroll);

    const updateInputWidth = () => {
      if (noteHeaderRef.current) {
        const width = noteHeaderRef.current.getBoundingClientRect().width;
        setInputWidth(`${width * 0.75}px`);
      }
    };

    // 立即更新一次宽度，以确保初始宽度正确
    updateInputWidth();

    // 监听窗口大小变化
    window.addEventListener('resize', updateInputWidth);

    // 组件卸载时移除监听器
    return () => {
      window.removeEventListener('resize', updateInputWidth);
      textarea.removeEventListener('scroll', onScroll);
    };
  }, []); // 空依赖数组意味着这个effect只在组件挂载时运行一次

  useEffect(() => {
    let timeUsage = 0;
      if (userDataLocal?.GPTVersion === 'GPT-3.5') {
        timeUsage = userDataLocal.Usage.time + tokenUsage / 10000;
      } else if (userDataLocal?.GPTVersion === 'GPT-4o mini') {
        timeUsage = userDataLocal.Usage.time + tokenUsage / 8000;
      } else {
        timeUsage = userDataLocal.Usage.time + tokenUsage / 1000;
      }
      // 保留小数点后两位
      timeUsage = Math.round(timeUsage * 100) / 100;
      if(!checkAndUpdateTimeUsage(timeUsage)) {
        upgradeUserLevel(true);
        saveNoteDetailAndClose();
      }
  }, [tokenUsage]);

  const checkAndUpdateTimeUsage = (timeUsage) => {
    // 计算使用时长，以分minute为单位
    let MAX_USAGE;
    if (userVipLevel === 0) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_FREE;
    } else if (userVipLevel === 1) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP1;
    } else if (userVipLevel === 2) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP2;
    }
    // let usageTotal = (userDataLocal?.Usage?.time || 0) + timeUsage;
    let usageTotal = timeUsage; // 直接拿传进来的已经累加好的值

    if (usageTotal > MAX_USAGE) {
      return false;
    } else {
      return true;
    }
  };

  const generateAudioUrl = async (noteID) => {
    // 构建请求 URL
    const noteid = noteID;
    // console.log('noteid:', noteid);
    const userid = user.uid;
    
    try {
      const response = await axios.get(`/api/upload/${userid}/${noteid}`);
      if (response.data.url) {
        // 成功获取音频文件的完整 URL
        // 你可以在这里使用这个 URL，例如在音频播放器中播放
        const audioElement = document.createElement('audio');
        let tempUrl = (response.data.url.includes('localhost')) ? response.data.url.replace('https:', 'http:') : response.data.url;
        setAudioUrl(tempUrl);

        // setAudioUrl(response.data.url);
      } else {
        console.error('Audio file URL not found in response');
      }
    } catch (err) {
      console.error('Network Error, please try again later!');
    }
  }

  useEffect(() => {
    if (textareaRefOFPolishedText.current) {
      autoResizeTextarea(textareaRefOFPolishedText.current);
    }
  }, [formattedPolishedText, view]);

  useEffect(() => {
    if (textareaRefOFTranscript.current) {
      autoResizeTextarea(textareaRefOFTranscript.current);
    }
  }, [formattedTranscript, view]);

  useEffect(() => {
    if (textareaRefOFSummary.current) {
      autoResizeTextarea(textareaRefOFSummary.current);
    }
  }, [formattedSummary, view]);

  useEffect(() => {
    if (noteID) {
      if (note.videoURL) {
        setVideoID(note.videoID)
        setVideoURL(note.videoURL)
        // console.log('note.videoURL:', note.videoURL);
      } else {
        if (window.location.hostname !== 'localhost') {
          generateAudioUrl(noteID);
        }
      }
      fetechTranscript(noteID);
    }
  }, [noteID]);

  // 当 messages 更新后，自动滚动到底部
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    if(messageChanged) {
      // setNoteDetailChanged(true);
      const shortMemory = Array.isArray(contextRef.current.shortMemory)
        ? contextRef.current.shortMemory
        : [];
      let memory = [...shortMemory];
      setTranscriptBody(prevState => {
        const updatedTranscriptBody = {
          ...prevState,
          message: messages,
          shortMemory: memory,
          summaryOfChat: contextRef.current.summaryOfChat
        };
        updateTranscriptionData(updatedTranscriptBody);
        return updatedTranscriptBody;
      });
      setMessageChanged(false);
    }
  }, [messages, messageChanged, streamingContent]);

  useEffect(() => {
    const newHash = generateContentHash(content);
    if (newHash === contextRef.current.lastContentHash || content === '') return;
    
    contextRef.current.lastContentHash = newHash;
    contextRef.current.systemPrompt = `Current reference content:\n${content}`;

    // const contentChangeMessage = {
    //   id: Date.now() + 1,
    //   user: 'Nvoice',
    //   avatar: nvoiceLogo,
    //   content: `Reference content has been updated to the latest version.`,
    //   timestamp: Date.now(),
    // };
    // setMessages((prev) => [...prev, contentChangeMessage]);
    // setMessageChanged(true);
  }, [content]);

  // 动态计算历史保留长度
  const getHistoryLimit = useCallback(() => {
    const systemToken = contextRef.current.systemPrompt.length / 4;
    const availableTokens = MAX_TOKENS - systemToken - 500; // 保留buffer
    return Math.floor(availableTokens / AVG_TOKEN_PER_MSG);
  }, []);

  // 在 AI 回复完成后设置焦点
  useEffect(() => {
    if (!isLoading && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isLoading]);

  // 生成摘要
  const generateSummary = useCallback(async (history) => {
    if (history.length === 0) {
      console.log('No history to summarize');
      return '';
    }
    try {
      const token = await checkToken();
      const response = await fetch('/api/summarize', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`, 
         },
        body: JSON.stringify({ 
          text: history.slice(0, -6).join('\n') // 保留最近3轮完整对话
        })
      });
      const data = await response.json();
      contextRef.current.summaryOfChat = data.summary;

      const contentChangeMessage = {
        id: Date.now() + 1,
        user: 'Nvoice',
        avatar: nvoiceLogo,
        content: `Conversation summary generated: ${data.summary}`,
        timestamp: Date.now(),
      };
      // let summaryNew =  [contentChangeMessage, ...messages.slice(-6)];
      // setMessages(prev => [contentChangeMessage, ...prev.slice(-6)]);
      return data.summary;
    } catch (error) {
      console.error('Summary generation failed:', error);
      return '';
    }
  }, []);

  // 构建智能消息
  const buildMessages = useCallback(async (userMessage) => {
    contextRef.current.systemPrompt = `Current reference content:\n${formatAndDisplayText(transcriptBody?.subtitleWithTimestamp || transcriptBody?.transcript || transcriptBody?.inputValue || formattedTranscript)}\n\n`;
    // console.log('contextRef.current.systemPrompt:', contextRef.current.systemPrompt, 'transcriptBody?.subtitleWithTimestamp', transcriptBody?.subtitleWithTimestamp);
    const systemMsg = contextRef.current.systemPrompt 
      ? [{ 
        id: Date.now() + 2,
        user: 'Nvoice',
        avatar: nvoiceLogo,
        content: contextRef.current.systemPrompt,
        timestamp: Date.now(),
      }]
      : [];
    
    // const historyLimit = getHistoryLimit();
    // // 确保 shortMemory 为数组
    // const shortMemory = Array.isArray(contextRef.current.shortMemory)
    //   ? contextRef.current.shortMemory
    //   : [];
    // let memory = [...shortMemory];
    
    // // 当历史超过限制时生成摘要
    // if (memory.length > historyLimit * 2) {
    //   const newSummary = await generateSummary(memory.map(m => m.content));
    //   memory = [
    //     { 
    //     id: Date.now() + 3,
    //     user: 'Nvoice',
    //     avatar: nvoiceLogo,
    //     content: `Conversation Summary: ${newSummary}`,  //${contextRef.current.summaryOfChat}
    //     timestamp: Date.now(),},
    //     ...memory.slice(-historyLimit * 2)
    //   ];
    // }

    const userQuestion = `The user's question is: ${userMessage}\n\n${defaultPrompt}`;

    const newUserMessage = {
      id: Date.now() + 4,
      user: userName,
      avatar: userAvatar,
      content: userQuestion,
      timestamp: Date.now(),
    };

    return [
      ...systemMsg,
      // ...memory,
      newUserMessage
    ];
  }, [getHistoryLimit, generateSummary, transcriptBody, formattedTranscript]);

  const estimateTokens = (text) => {
    // 计算文本的字节数
    const byteSize = new Blob([text]).size;
    
    // 估算token数量，假设每个token大约4个字节
    const tokens = Math.ceil(byteSize / 4);
    
    return tokens;
  };

  //________________________________________________________
  //2025.04.03
  const getLastTimestampHour = (content) => {
    if (!content) return 0;
    
    // 查找所有时间戳 [HH:MM:SS]
    const timestampMatches = content.match(/\[(\d{2}):(\d{2}):(\d{2})\]/g);
    
    if (!timestampMatches || timestampMatches.length === 0) {
      return 0;
    }
    
    // 获取最后一个时间戳
    const lastTimestamp = timestampMatches[timestampMatches.length - 1];
    // 提取小时数值
    const hourMatch = lastTimestamp.match(/\[(\d{2}):/);
    
    if (hourMatch && hourMatch[1]) {
      return parseInt(hourMatch[1], 10);
    }
    
    return 0;
  };

  const handleStreamResponse = useCallback(async (usermessage) => {
    let userMessage = usermessage;
    let gptModel = 'gpt-4.1-mini'
    if (userMessage.includes('NvoiceAPI=Gemini')) { 
      userMessage = userMessage.replace('', 'NvoiceAPI=Gemini');
      gptModel = 'Gemini';
    } else if (userMessage.includes('NvoiceAPI=gpt-4.1-mini')) {
      userMessage = userMessage.replace('', 'NvoiceAPI=gpt-4.1-mini');
      gptModel = 'gpt-4.1-mini';
    } else if (userMessage.includes('NvoiceAPI=gpt-4.1-nano')) {
      userMessage = userMessage.replace('', 'NvoiceAPI=gpt-4.1-nano');
      gptModel = 'gpt-4.1-nano';
    } else if (userMessage.includes('NvoiceAPI=gpt-4o-mini')) {
      userMessage = userMessage.replace('', 'NvoiceAPI=gpt-4o-mini');
      gptModel = 'gpt-4o-mini';
    }
    // const gptModel = userMessage.includes('时间戳标记') ? true : false;
    const messages = await buildMessages(userMessage);
    
    // 检查是否包含时间戳并且内容超长
    const containsTimestamps = /\[\d{2}:\d{2}:\d{2}\]/.test( messages[0]?.content || '');
    const contentLength = messages[0]?.content?.length || 0;
    const lastTimestampHour = getLastTimestampHour(messages[0]?.content) || 0;
    const isLongTimestampContent = containsTimestamps && contentLength > 110000 && lastTimestampHour >= 3;
    console.log('contentLength:', contentLength, 'containsTimestamps', containsTimestamps, 'lastTimestampHour:', lastTimestampHour, 'isLongTimestampContent:', isLongTimestampContent);
    // return;
    contextRef.current.controller = new AbortController();
    let tokensUse = 0;
    let fullResponse = '';

    try {
      const token = await checkToken();
      
      // 如果是长时间戳内容，进行分片处理
      if (isLongTimestampContent && messages[0]?.content) {
        setIsLoading(true);
        setIsStreaming(true);
        
        // 显示处理提示
        setStreamingContent('Processing long transcript with timestamps, please wait...\n\n');
        
        // 按时间戳分片，每60分钟为一个片段
        const segments = splitContentByTimestamp(messages[0].content);
        let combinedResponse = '';
        console.log('segments.length:', segments.length);
        // return;
        
        for (let i = 0; i < segments.length; i++) {
          // 更新进度提示
          setStreamingContent(prev => `${prev.replace(/Processing segment \d+\/\d+.../g, '')}Processing segment ${i+1}/${segments.length}...\n`);
          
          // 为每个片段创建新的消息数组
          const segmentMessages = [
            {
              ...messages[0],
              content: `Current reference content: ${segments[i]}\n\n`
            },
            // ...messages.slice(-1) // 只保留用户最后的问题
            //IMPORTANT: This is part ${i+1} of ${segments.length} from the reference content. When answering, focus only on information available in this segment.
            {
              id: Date.now() + 4,
              user: userName,
              avatar: userAvatar,
              // content: `The user's question is: ${userMessage}\n\n${defaultUserPrompt}`,
              content: `The user's question is: ${userMessage}\n\n
                IMPORTANT CONTEXT: You are analyzing segment ${i+1} of ${segments.length} of the transcript.
                When referring to timestamps, PRESERVE THE ABSOLUTE TIMING from the original video.
                DO NOT reset timestamps to 00:00:00 for this segment.
                The timestamps in this segment are continuous with previous segments.`,
              timestamp: Date.now(),
            }
          ];
          
          const transformedSegmentMessages = segmentMessages.map(msg => ({
            role: msg.user === 'Nvoice' ? 'system' : 'user',
            content: (typeof msg?.content === 'string') ? msg.content : ''
          }));
          
          // 处理当前片段
          const segmentResponse = await processSegment(
            transformedSegmentMessages, 
            token, 
            gptModel, 
            contextRef.current.controller
          );
          
          // 合并响应
          combinedResponse += (i > 0 ? '\n\n' : '') + segmentResponse;
          tokensUse += estimateTokens(segmentResponse);
          combinedResponse = 'The reference content is:\n' + combinedResponse;
          
          // 更新流式输出
          setStreamingContent(`${combinedResponse}\n\n${i < segments.length-1 ? 'Continuing analysis...' : 'Finalizing response...'}`);
        }
        
        // 最终处理 - 汇总所有结果
        if (segments.length > 1) {
          const summaryPrompt = {
            role: 'user',
            // content: `I've analyzed the transcript in ${segments.length} parts and found the following information:\n\n${combinedResponse}\n\nPlease provide a concise, well-organized final answer to my original question: "${userMessage}"\n\n${defaultPrompt}`
            //  content: `${userMessage}"\n\n${defaultPrompt}`
             content: `${userMessage}\n\n
              IMPORTANT: I've analyzed the transcript in ${segments.length} parts, each covering different time ranges.
              When providing your final answer:
              1. PRESERVE ALL ORIGINAL TIMESTAMPS exactly as they appear in the source
              2. MAINTAIN CHRONOLOGICAL ORDER of all events/points
              3. DO NOT reset or adjust timestamps - they should reflect absolute time in the original video
              4. Ensure timestamp format is consistent: [HH:MM:SS]
              
              ${defaultPrompt}`
          };
          
          const summaryMessages = [
            {
              role: 'system',
              // content: 'You are summarizing multiple analysis results from a long transcript with timestamps. Organize the information coherently, remove duplicates, and ensure all relevant timestamps are preserved in [HH:MM:SS] format.'
              content: combinedResponse
            },
            summaryPrompt
          ];
          
          setStreamingContent(prev => `${prev}\n\nOrganizing final response...`);
          
          // 获取最终汇总响应
          const finalResponse = await processSegment(
            summaryMessages, 
            token, 
            gptModel, 
            contextRef.current.controller
          );
          
          fullResponse = finalResponse;
        } else {
          // 只有一个片段的情况
          fullResponse = combinedResponse;
        }
      } else {
        // 常规处理方式（原有逻辑）
        const transformedMessages = messages.map(msg => ({
          role: msg.user === 'Nvoice' ? 'system' : 'user',
          content: (typeof msg?.content === 'string') ? msg.content : ''
        }));
        
        const response = await fetch('https://www.metaspringai.net/api/chat/stream', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, 
          },
          body: JSON.stringify({ messages: transformedMessages, gptModel: gptModel }),
          signal: contextRef.current.controller.signal
        });
        
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        fullResponse = '';
        setIsStreaming(true);

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          
          let chunk = decoder.decode(value);
          chunk = chunk
            .replace(/^data: /gm, '')
            .replace(/\n/gm, '')
            .replace(/<br\/>/gm, '  ')
            .replace(/&nbsp;/gm, ' ')
            .replace(/\[DONE\]/gm, '')
            .replace(/\*\*/gm, '')
            .replace(/"+/gm, '')
            .replace(/'/gm, '');
            
          setStreamingContent(prev => prev.replace(/^Nvoice thinking/gm, '') + chunk);
          fullResponse += chunk;
        }
      }
      
      // 计算token使用量并更新状态
      tokensUse += estimateTokens(fullResponse) + estimateTokens(userMessage);
      setTokenUsage(prev => prev + tokensUse);
      
      // 更智能的错误检测逻辑
      const isApiError = (response) => {
        // 检测明确的API错误模式
        const errorPatterns = [
          /^error:/i,                      // 以error:开头
          /API Error:/i,                   // API错误标识
          /^Exception:/i,                  // 异常标识
          /\{\"error\":/i,                 // JSON错误格式
          /Connection refused/i,           // 连接被拒
          /^Failed to/i,                   // 明确的失败标识
          /status code [45]\d\d/i          // HTTP错误状态码
        ];
        
        // 检查是否符合任何错误模式
        return errorPatterns.some(pattern => pattern.test(response));
      };

      // 替换原有代码
      if(isApiError(fullResponse)) {
        fullResponse = 'Network Error, please refresh current page and try again.';
        // window.location.reload(); 
      }
      // 创建新的消息条目
      const newEntry = [
        {  
          id: Date.now() + 1,
          user: 'Nvoice',
          avatar: nvoiceLogo,
          content: fullResponse,
          timestamp: Date.now() 
        }
      ];

      // 更新消息和状态
      setMessages(prev => [...prev, ...newEntry]);
      setMessageChanged(true);
      setStreamingContent('');
      
      // 更新短期记忆
      const shortMemory = Array.isArray(contextRef.current.shortMemory) ? contextRef.current.shortMemory : [];
      contextRef.current.shortMemory = [...shortMemory, ...newEntry];
      
      return;
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Streaming request failed:', error);
      }
      setStreamingContent('');
    } finally {
      setIsStreaming(false);
      setIsLoading(false);
      setStreamingContent('');
    }
  }, [buildMessages, messages]);

  // 辅助函数：按时间戳分段内容
  // const splitContentByTimestamp = (content) => {
  //   // 如果找不到时间戳格式，则直接返回整个内容
  //   if (!content.match(/\[(\d{2}):(\d{2}):(\d{2})\]/)) {
  //     return [content];
  //   }
    
  //   const segments = [];
  //   const timeRanges = [];
  //   let currentSegment = '';
  //   let lastHour = -1;
  //   let segmentStartTime = null;
    
  //   // 按行处理内容
  //   const lines = content.split('\n');
  //   for (const line of lines) {
  //     // 尝试提取时间戳 [HH:MM:SS]
  //     const timeMatch = line.match(/\[(\d{2}):(\d{2}):(\d{2})\]/);
      
  //     if (timeMatch) {
  //       const hours = parseInt(timeMatch[1]);
  //       const minutes = parseInt(timeMatch[2]);
  //       const seconds = parseInt(timeMatch[3]);
  //       const totalMinutes = hours * 60 + minutes;
        
  //       // 如果是第一个时间戳或者与上一时间戳在同一小时内
  //       if (lastHour === -1 || Math.floor(totalMinutes / 60) === lastHour) {
  //         if (lastHour === -1) {
  //           segmentStartTime = `[${timeMatch[1]}:${timeMatch[2]}:${timeMatch[3]}]`;
  //           lastHour = Math.floor(totalMinutes / 60);
  //         }
  //         currentSegment += line + '\n';
  //       } else if (Math.floor(totalMinutes / 60) - lastHour >= 1) {
  //         // 如果时间戳超过上一小时，创建新片段
  //         const endTime = `[${timeMatch[1]}:${timeMatch[2]}:${timeMatch[3]}]`;
  //         timeRanges.push(`${segmentStartTime} to ${endTime}`);
          
  //         segments.push(currentSegment.trim());
  //         currentSegment = `Continuing from ${endTime}:\n${line}\n`;
  //         segmentStartTime = endTime;
  //         lastHour = Math.floor(totalMinutes / 60);
  //       }
  //     } else {
  //       // 非时间戳行，直接添加到当前片段
  //       currentSegment += line + '\n';
  //     }
  //   }
    
  //   // 添加最后一个片段
  //   if (currentSegment.trim()) {
  //     segments.push(currentSegment.trim());
  //   }
    
  //   // 如果只有一个片段，直接返回完整内容
  //   if (segments.length <= 1) {
  //     return [content];
  //   }
    
  //   // 为每个片段添加时间范围说明
  //   return segments.map((segment, i) => {
  //     return `Content segment ${i+1}/${segments.length} (${timeRanges[i] || 'time range unknown'}):\n\n${segment}`;
  //   });
  // };

  //________________________________________________________
  // 辅助函数：按时间戳分段内容 2025.05.23
  const splitContentByTimestamp = (content) => {
    // 如果找不到时间戳格式，则直接返回整个内容
    if (!content.match(/\[(\d{2}):(\d{2}):(\d{2})\]/)) {
      return [content];
    }
    
    const segments = [];
    const timeRanges = [];
    const segmentMetadata = []; // 新增：保存每个段落的元数据
    let currentSegment = '';
    let lastHour = -1;
    let segmentStartTime = null;
    let segmentStartHour = -1;
    
    // 按行处理内容
    const lines = content.split('\n');
    for (const line of lines) {
      // 尝试提取时间戳 [HH:MM:SS]
      const timeMatch = line.match(/\[(\d{2}):(\d{2}):(\d{2})\]/);
      
      if (timeMatch) {
        const hours = parseInt(timeMatch[1]);
        const minutes = parseInt(timeMatch[2]);
        const seconds = parseInt(timeMatch[3]);
        const totalMinutes = hours * 60 + minutes;
        
        // 如果是第一个时间戳或者与上一时间戳在同一小时内
        if (lastHour === -1 || Math.floor(totalMinutes / 60) === lastHour) {
          if (lastHour === -1) {
            segmentStartTime = `[${timeMatch[1]}:${timeMatch[2]}:${timeMatch[3]}]`;
            lastHour = Math.floor(totalMinutes / 60);
            segmentStartHour = hours;
          }
          currentSegment += line + '\n';
        } else if (Math.floor(totalMinutes / 60) - lastHour >= 1) {
          // 如果时间戳超过上一小时，创建新片段
          const endTime = `[${timeMatch[1]}:${timeMatch[2]}:${timeMatch[3]}]`;
          timeRanges.push(`${segmentStartTime} to ${endTime}`);
          
          // 保存当前段落的开始小时和结束小时
          segmentMetadata.push({
            startHour: segmentStartHour,
            endHour: hours,
            startTime: segmentStartTime,
            endTime: endTime
          });
          
          segments.push(currentSegment.trim());
          currentSegment = `Continuing from ${endTime}:\n${line}\n`;
          segmentStartTime = endTime;
          segmentStartHour = hours;
          lastHour = Math.floor(totalMinutes / 60);
        }
      } else {
        // 非时间戳行，直接添加到当前片段
        currentSegment += line + '\n';
      }
    }
    
    // 添加最后一个片段
    if (currentSegment.trim()) {
      segments.push(currentSegment.trim());
      
      // 最后一个片段的元数据可能没有明确的结束时间
      // 使用最后看到的时间作为结束时间
      segmentMetadata.push({
        startHour: segmentStartHour,
        endHour: lastHour + 1, // 估计结束小时
        startTime: segmentStartTime,
        endTime: `约${lastHour + 1}小时结束`
      });
    }
    
    // 如果只有一个片段，直接返回完整内容
    if (segments.length <= 1) {
      return [content];
    }
    
    // 为每个片段添加时间范围说明和上下文提示
    return segments.map((segment, i) => {
      const metadata = segmentMetadata[i];
      const previousMetadata = i > 0 ? segmentMetadata[i-1] : null;
      const nextMetadata = i < segmentMetadata.length - 1 ? segmentMetadata[i+1] : null;
      
      // 增强段落上下文，包含绝对时间信息和相对位置信息
      let contextHeader = `Content segment ${i+1}/${segments.length} - ABSOLUTE TIME RANGE: ${metadata.startHour} hour to ${metadata.endHour} hour\n`;
      contextHeader += `This segment covers from ${metadata.startTime} to ${metadata.endTime || '视频结束'}.\n`;
      
      // 添加前后文关系提示
      if (previousMetadata) {
        contextHeader += `Previous segment ended at ${previousMetadata.endTime}. `;
      }
      if (nextMetadata) {
        contextHeader += `Next segment begins at ${nextMetadata.startTime}.\n`;
      }
      
      contextHeader += `\nIMPORTANT: ALL TIMESTAMPS IN THIS SEGMENT SHOULD BE INTERPRETED AS ${metadata.startHour}-${metadata.endHour} HOUR RANGE.\n\n`;
      
      return contextHeader + segment;
    });
  };
  //________________________________________________________

  // 辅助函数：处理单个片段
  const processSegment = async (messages, token, gptModel, controller) => {
    const response = await fetch('/api/chat/stream', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`, 
      },
      body: JSON.stringify({ 
        messages: messages, 
        gptModel: gptModel 
      }),
      signal: controller.signal
    });

    
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let segmentResponse = '';
    
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      
      let chunk = decoder.decode(value);
      chunk = chunk
        .replace(/^data: /gm, '')
        .replace(/\n/gm, '')
        .replace(/<br\/>/gm, '  ')
        .replace(/&nbsp;/gm, ' ')
        .replace(/\[DONE\]/gm, '')
        .replace(/\*\*/gm, '')
        .replace(/"+/gm, '')
        .replace(/'/gm, '');
        
      segmentResponse += chunk;
    }
    
    return segmentResponse;
  };

  //________________________________________________________

  const preSetUserName = () => {
    const name = userDataLocal.Name;
    let username = name;
    if (name.includes('@')) {
        username = name.split('@')[0];
    }
    setUserName(username);
  }

  const preSetTranscript = (transcript) => {
    // if (transcript.startsWith('WEBVTT')) {
    //   const lines = transcript.split('\n');
    //   if (lines.length > 3 && lines[0] === 'WEBVTT' && lines[1].startsWith('Kind:') && lines[2].startsWith('Language:')) {
    //     setFormattedTranscript(lines.slice(3).join('\n'));
    //   } else {
    //     setFormattedTranscript(transcript);
    //   }
    // } else {
    //   setFormattedTranscript(transcript);
    // }
    // 清理每行首尾空格并重新拼接
    const cleanLines = (text) =>
      text
        .split('\n')
        .map(line => line.trim())
        .join('\n');

    if (transcript.startsWith('WEBVTT')) {
      const lines = transcript.split('\n');
      if (
        lines.length > 3 &&
        lines[0] === 'WEBVTT' &&
        lines[1].startsWith('Kind:') &&
        lines[2].startsWith('Language:')
      ) {
        setFormattedTranscript(cleanLines(lines.slice(3).join('\n')));
      } else {
        setFormattedTranscript(cleanLines(transcript));
      }
    } else {
      setFormattedTranscript(cleanLines(transcript));
    }
  }

  // —————————————————————————————————————————————————2024.12.06

  const fetechTranscript = async(noteID) => {
    const noteExists = transcriptDataBuffer.some(item => item.noteID === noteID);
    const noteInUserDataLocal = userDataLocal.History.find(item => item.noteID === noteID);
    const transcriptExistInNote = noteInUserDataLocal && noteInUserDataLocal.transcript !== '';
    if (!noteExists && !transcriptExistInNote) {
      let TandPandS = await fetchTrascriptionData(noteID); 
      if(TandPandS && TandPandS?.transcribeID && TandPandS?.transcribeID !== 'Done'){
        const transcribeID = TandPandS.transcribeID;
        let responseData = await checkTranscriptionStatus(transcribeID, noteID);
        if (TandPandS?.videoID && TandPandS?.videoURL && (!responseData?.transcriptionText || responseData?.transcriptionText === 'Transcript updating...')) {
          const videoData0417 = await getVideoData(TandPandS?.videoID, TandPandS?.videoURL);
          const { Transcript, subtitleWithTimestamp } = videoData0417;
          if (Transcript && Transcript !== '' && Transcript !== 'Transcript updating...') {
            responseData = {
              transcriptionText: Transcript,
              subtitleWithTimestamp: subtitleWithTimestamp
            };
          }
        }
        if(responseData){
          const speakerTranscrition = responseData.transcriptionText;
          const subtitleWithTimestamp = responseData.subtitleWithTimestamp;
          if (speakerTranscrition === null || speakerTranscrition === 'Transcript updating...') {
            console.log('Transcribing not completed or task failure, please try again later!');
          } else {
            const inputValueOfTandP = TandPandS.inputValue;
            const newNote = {
              ...TandPandS,
              inputValue: inputValueOfTandP === 'Transcript updating...' ? speakerTranscrition : inputValueOfTandP,
              transcript: speakerTranscrition,  
              subtitleWithTimestamp: subtitleWithTimestamp,
              transcribeID: 'Done'
            };
            console.log('Call updateTranscriptionData. transcriptBody:', newNote);
            updateTranscriptionData(newNote);
            TandPandS = newNote;

            const videoID = TandPandS?.videoID;
            if (videoID && TandPandS?.videoURL) {
              const newVideoData = { 
                Transcript: speakerTranscrition,
                subtitleWithTimestamp: subtitleWithTimestamp
              }
              updateVideoData(videoID, newVideoData);
            }
          }
        } else {
          console.error('Error fetching transcription data:', responseData);
        }
      }
      // _________________________________________________________
      if(TandPandS){
        let transcriptText = TandPandS.transcript || TandPandS.inputValue;
        if (transcriptText === null || transcriptText === 'Transcript updating...' || transcriptText === '') {
          console.log('Transcribing not completed or task failure, please try again later!');
        } else {
          const textForGpt = TandPandS?.subtitleWithTimestamp || transcriptBody?.subtitleWithTimestamp || transcriptText;
          if(!TandPandS.summary || TandPandS.summary.includes('处理请求失败') || TandPandS.summary.includes('无法处理') || TandPandS.summary.includes('处理失败') || TandPandS.summary.includes('无法进行') || TandPandS.summary.includes('无法完成') || TandPandS.summary.includes('无法满足') || TandPandS.summary.includes('请提供更多') || TandPandS.summary.includes('无法生成') || TandPandS.summary.includes('无法提供') || TandPandS.summary.includes('抱歉') || TandPandS.summary.includes('请提供') || TandPandS.summary.includes('Failed to process the request')  || TandPandS.summary.includes('Sorry, I cannot') || TandPandS.title.includes('处理请求失败') || TandPandS.title.includes('无法处理') || TandPandS.title.includes('处理失败') || TandPandS.title.includes('无法进行') || TandPandS.title.includes('无法完成') || TandPandS.title.includes('Failed to process the request') || ((TandPandS.title === 'Title updating...' || TandPandS.outline === 'Updating...' || TandPandS.keywords === 'Updating...' || !TandPandS.title || !TandPandS.outline || !TandPandS.keywords) && (noteInUserDataLocal && (noteInUserDataLocal?.title === 'Title updating...' || noteInUserDataLocal?.title === '' || noteInUserDataLocal?.outline === 'Updating...' || noteInUserDataLocal?.outline === '' || noteInUserDataLocal?.keywords === 'Updating...' || noteInUserDataLocal?.keywords === '')))){
            let gptVersion = 'gpt-4o-mini';
            const videoId = noteInUserDataLocal.videoID;
            const videoUrl = noteInUserDataLocal.videoURL;
            const result = await getGPTResponse(textForGpt, userDataLocal?.SummarySet, userDataLocal?.SummaryLength, gptVersion, userDataLocal?.Language?.lan, userDataLocal?.GPTPromptContent || GPT_PROMPT_CONTENT.prompt, userVipLevel, '', '', videoUrl);
            let polishedTextFromGPT = result.polishedText.replace(/\*\*/g, '');
            let summaryText = result.summary.replace(/^Summary:/, '').replace(/\*\*/g, '');
            let keywordsText = result.keywords.replace(/^Keywords:/, '').replace(/\*\*/g, '');
            let outlineText = result.outline.replace(/^Outline:/, '').replace(/\*\*/g, '');
            let titleText = result.title.replace(/^Title:/, '').replace(/\*\*/g, '');
            let newChapterForMessages = TandPandS?.message || transcriptBody?.message || [];
            if(result?.chapters && result?.chapters !== 'Updating...' && (typeof result?.chapters === 'string' && result.chapters.trim() !== '')) {
              newChapterForMessages = [
                ...(newChapterForMessages || []),
                // 只有 chapters 有效时才追加
                ...(result.chapters ? [{
                  id: Date.now(),
                  user: 'Nvoice',
                  avatar: nvoiceLogo,
                  content: result.chapters,
                  timestamp: Date.now(),
                }] : [])
              ]
            }
            if(videoUrl && videoId){
              titleText = noteInUserDataLocal.title || TandPandS.title;
            }
            const inputValueOfTandP = TandPandS.inputValue;
            if(transcriptText || polishedTextFromGPT || summaryText){
              const newTranscriptBody = {
                ...TandPandS,
                noteID: noteInUserDataLocal.noteID,
                transcribeID: 'Done',
                inputValue: transcriptText,
                transcript: transcriptText,
                polishedText: polishedTextFromGPT,
                summary: summaryText,
                videoURL: videoUrl,
                videoID: videoId,
                keywords: keywordsText,
                outline: outlineText,
                title: titleText,
                message: newChapterForMessages,
                shortMemory:  TandPandS?.shortMemory || transcriptBody?.shortMemory || [],
                summaryOfChat:  TandPandS?.summaryOfChat || transcriptBody?.summaryOfChat || '',
                subtitleWithTimestamp: TandPandS?.subtitleWithTimestamp || transcriptBody?.subtitleWithTimestamp || ''
              }
              if(transcriptText && polishedTextFromGPT && videoUrl) {
                const newVideoData = { Transcript: transcriptText, PolishedText: polishedTextFromGPT }
                updateVideoData(videoId, newVideoData);
              }

              setNoteLocal(prevState => ({
                ...prevState,
                keywords: keywordsText,
                outline: outlineText,
                title: titleText
              }));
              setNoteDetailChanged(true);
              setCurrentUpdateReason('historyChanged');

              console.log('Call updateTranscriptionData. newTranscriptBody:', newTranscriptBody);
              updateTranscriptionData(newTranscriptBody);
              TandPandS = newTranscriptBody;
            }
          }
        }
      }
      // _________________________________________________________
      
      if (TandPandS) {
        dataSetForTranscript(TandPandS);
      } else {
        setTranscriptDataExist(false);
        setTranscriptBody(null);
      }
    } else {
      let TandPandS = transcriptDataBuffer.find(item => item.noteID === noteID);
      if (TandPandS.transcribeID === 'Done') {
        // dataSetForTranscript(TandPandS);
        // console.log('TandPandS.transcribeID === Done. TandPandS:', TandPandS);
      } else {
        let responseData = await checkTranscriptionStatus(TandPandS.transcribeID, noteID);

        if (TandPandS?.videoID && TandPandS?.videoURL && (!responseData?.transcriptionText || responseData?.transcriptionText === 'Transcript updating...')) {
          const videoData0417 = await getVideoData(TandPandS?.videoID, TandPandS?.videoURL);
          const { Transcript, subtitleWithTimestamp } = videoData0417;
          if (Transcript && Transcript !== '' && Transcript !== 'Transcript updating...') {
            responseData = {
              transcriptionText: Transcript,
              subtitleWithTimestamp: subtitleWithTimestamp
            };
          }
        }

        if(responseData){
          const speakerTranscrition = responseData.transcriptionText;
          const subtitleWithTimestamp = responseData.subtitleWithTimestamp;
          if (speakerTranscrition === null || speakerTranscrition === 'Transcript updating...') {
            console.log('Transcribing not completed or task failure, please try again later!');
            // dataSetForTranscript(TandPandS);
          } else {
            const inputValueOfTandP = TandPandS.inputValue;
            const newNote = {
              ...TandPandS,
              inputValue: inputValueOfTandP === 'Transcript updating...' ? speakerTranscrition : inputValueOfTandP,
              transcript: speakerTranscrition,  
              subtitleWithTimestamp: subtitleWithTimestamp,
              transcribeID: 'Done'
            };
            // console.log('call updateTranscriptionData. newNote:', newNote);
            updateTranscriptionData(newNote);
            
            // dataSetForTranscript(newNote);
            // setTranscriptDataBuffer(transcriptDataBuffer.map(item => 
            //   item.noteID === noteID ? newNote : item
            // ));      
            const videoID = TandPandS?.videoID;
            if (videoID && TandPandS?.videoURL) {
              const newVideoData = { 
                Transcript: speakerTranscrition,
                subtitleWithTimestamp: subtitleWithTimestamp
              }
              updateVideoData(videoID, newVideoData);
            }
            TandPandS = newNote;
          }
        } else {
          console.error('Error fetching transcription data:', responseData);
        }
      }

      let transcriptText = TandPandS.transcript || TandPandS.inputValue;
      if (transcriptText === null || transcriptText === 'Transcript updating...' || transcriptText === '') {
        console.log('Transcribing not completed or task failure, please try again later!');
      } else {
        const textForGpt = TandPandS?.subtitleWithTimestamp || transcriptBody?.subtitleWithTimestamp || transcriptText;
        if(!TandPandS.summary || TandPandS.summary.includes('处理请求失败') || TandPandS.summary.includes('无法处理') || TandPandS.summary.includes('处理失败') || TandPandS.summary.includes('无法进行') || TandPandS.summary.includes('无法完成') || TandPandS.summary.includes('无法满足') || TandPandS.summary.includes('请提供更多') || TandPandS.summary.includes('无法生成') || TandPandS.summary.includes('无法提供') || TandPandS.summary.includes('抱歉') || TandPandS.summary.includes('请提供') || TandPandS.summary.includes('Failed to process the request')  || TandPandS.summary.includes('Sorry, I cannot') || TandPandS.title.includes('处理请求失败') || TandPandS.title.includes('无法处理') || TandPandS.title.includes('处理失败') || TandPandS.title.includes('无法进行') || TandPandS.title.includes('无法完成') || TandPandS.title.includes('Failed to process the request') || ((TandPandS.title === 'Title updating...' || TandPandS.outline === 'Updating...' || TandPandS.keywords === 'Updating...' || !TandPandS.title || !TandPandS.outline || !TandPandS.keywords) && (noteInUserDataLocal && (noteInUserDataLocal?.title === 'Title updating...' || noteInUserDataLocal?.title === '' || noteInUserDataLocal?.outline === 'Updating...' || noteInUserDataLocal?.outline === '' || noteInUserDataLocal?.keywords === 'Updating...' || noteInUserDataLocal?.keywords === '')))){
          let gptVersion = 'gpt-4o-mini';
          
          const videoId = noteInUserDataLocal.videoID;
          const videoUrl = noteInUserDataLocal.videoURL;
          const result = await getGPTResponse(textForGpt, userDataLocal?.SummarySet, userDataLocal?.SummaryLength, gptVersion, userDataLocal?.Language?.lan, userDataLocal?.GPTPromptContent || GPT_PROMPT_CONTENT.prompt, userVipLevel, '', '', videoUrl);
          let polishedTextFromGPT = result.polishedText.replace(/\*\*/g, '');
          let summaryText = result.summary.replace(/^Summary:/, '').replace(/\*\*/g, '');
          let keywordsText = result.keywords.replace(/^Keywords:/, '').replace(/\*\*/g, '');
          let outlineText = result.outline.replace(/^Outline:/, '').replace(/\*\*/g, '');
          let titleText = result.title.replace(/^Title:/, '').replace(/\*\*/g, '');
          let newChapterForMessages = TandPandS?.message || transcriptBody?.message || [];
          if(result?.chapters && result?.chapters !== 'Updating...' && (typeof result?.chapters === 'string' && result.chapters.trim() !== '')) {
            newChapterForMessages = [
              ...(newChapterForMessages || []),
              // 只有 chapters 有效时才追加
              ...(result.chapters ? [{
                id: Date.now(),
                user: 'Nvoice',
                avatar: nvoiceLogo,
                content: result.chapters,
                timestamp: Date.now(),
              }] : [])
            ]
          }
          if(videoUrl && videoId){
            titleText = noteInUserDataLocal.title || TandPandS.title;
          }
          
          if(transcriptText || polishedTextFromGPT || summaryText){
            const newTranscriptBody = {
              ...TandPandS,
              noteID: noteInUserDataLocal.noteID,
              transcribeID: 'Done',
              inputValue: transcriptText,
              transcript: transcriptText,
              polishedText: polishedTextFromGPT,
              summary: summaryText,
              videoURL: videoUrl,
              videoID: videoId,
              keywords: keywordsText,
              outline: outlineText,
              title: titleText,
              message: newChapterForMessages,
              shortMemory:  TandPandS?.shortMemory || transcriptBody?.shortMemory || [],
              summaryOfChat:  TandPandS?.summaryOfChat || transcriptBody?.summaryOfChat || '',
              subtitleWithTimestamp: TandPandS?.subtitleWithTimestamp || transcriptBody?.subtitleWithTimestamp || ''
            }
            if(transcriptText && polishedTextFromGPT && videoUrl) {
              const newVideoData = { Transcript: transcriptText, PolishedText: polishedTextFromGPT }
              updateVideoData(videoId, newVideoData);
            }

            // setNotes(array); 
            // if (!ifNoteIDExist) setNeedUpdate(true);
            // 这里将 notes 数组中 noteID 等于 noteInUserDataLocal.noteID 的项更新 keywords、outline 和 title；
            setNoteLocal(prevState => ({
              ...prevState,
              keywords: keywordsText,
              outline: outlineText,
              title: titleText
            }));
            setNoteDetailChanged(true);
            setCurrentUpdateReason('historyChanged');

            // console.log('Call updateTranscriptionData. newTranscriptBody:', newTranscriptBody);
            updateTranscriptionData(newTranscriptBody);
            TandPandS = newTranscriptBody;
            if (TandPandS) {
              // dataSetForTranscript(TandPandS);
              // setTranscriptDataBuffer( [...transcriptDataBuffer, TandPandS] );
            } else {
              setTranscriptDataExist(false);
              setTranscriptBody(null);
            }
          }
        }
      }
      dataSetForTranscript(TandPandS);

      // transcriptDataBuffer.forEach(item => {
      //   if (item.noteID === noteID) {
      //     dataSetForTranscript(item);
      //   }
      // });
    }
  }

  //2025.01.11
  const checkTranscriptionStatus = async (id, noteID) => {
    try {
      const response = await axios.get('/api/checkTranscriptionStatus', { 
              params: { id, uid: user.uid, noteIDnum: noteID }
            });
      if (response.data.status === 'Succeeded') {
        // console.log('Succeeded! Transcription is:', response.data.transcriptionText);
        // console.log('Succeeded! response.data.resdata:', response.data.resdata);
        return response.data;
      } else if (response.data.status === 'Failed') {
        console.error('Transcription failed, error or response.data is:', response.data.properties.error || response.data);
        return null;
      } else {
        return {transcriptionText: 'Transcript updating...', subtitleWithTimestamp: ''};
      }
    } catch (error) {
      console.error('Error checking transcription status:', error);
      return null;
    }
  };

  const dataSetForTranscript = (TandPandS) => {
    setTranscriptBody(TandPandS);  //transcriptData
    setTranscriptDataExist(true);
    setFormattedPolishedText(formatAndDisplayText(TandPandS.polishedText))
    preSetTranscript(formatAndDisplayText(TandPandS.transcript))
    setFormattedSummary(formatAndDisplayText(TandPandS.summary))
    setFormattedGptresponse(formatAndDisplayText(TandPandS.gptresponse))
    let title = TandPandS?.title || note.title || '';
    setFormattedTitle(title.replace(/"/g, ''))
    setFormattedKeywords(TandPandS?.keywords || note.title || '')
    setFormattedOutline(formatAndDisplayText(TandPandS?.outline || note.title || ''))
    if((TandPandS.title && TandPandS.title !== 'Title updating...' && TandPandS.outline && TandPandS.outline !== 'Updating...' && TandPandS.keywords && TandPandS.keywords !== 'Updating...') && (note.title ==='' || note.title === 'Title updating...' || note.outline === '' || note.outline === 'Updating...' && note.keywords === '' || note.keywords === 'Updating...')){
      setNoteLocal(prevState => ({
        ...prevState,
        keywords: TandPandS.keywords,
        outline: TandPandS.outline,
        title: TandPandS.title
      }));
    }

    if (TandPandS.message && Array.isArray(TandPandS.message) && TandPandS.message.length > (messages?.length || 0)) {
      setMessages(TandPandS.message);
      contextRef.current.shortMemory = TandPandS.shortMemory;
      contextRef.current.summaryOfChat = TandPandS.summaryOfChat;
      contextRef.current.systemPrompt = `Current reference content:\n${formatAndDisplayText(TandPandS.transcript)}`;
    }

    if(TandPandS?.title && TandPandS?.keywords && TandPandS?.outline && (noteLocal.title !== TandPandS.title || noteLocal.keywords !== TandPandS.keywords || noteLocal.outline !== TandPandS.outline)){ 
      setNoteLocal(prevState => ({
        ...prevState,
        keywords: TandPandS.keywords,
        outline: TandPandS.outline,
        title: TandPandS.title
      }));
      setNoteDetailChanged(true);
      setCurrentUpdateReason('historyChanged');
    }
  }

  function formatAndDisplayText(polishedText) {
    if (polishedText) {
      return polishedText
        // 先将所有"-__-"替换为换行符
        .replace(/-__-/g, '\n')
        // 处理标点符号后的换行：匹配句号、感叹号、问号、分号、中文标点及引号后面的空白
        .replace(/([.!?;。！？；"])\s*/g, (match, p1, offset, string) => {
          // 如果是句号，需要判断是否属于小数或编号
          if (p1 === '.') {
            // 检查是否为小数（例如 "3.14"）
            if (/\d\.\d/.test(string.slice(offset - 1, offset + 2))) {
              return match;
            }
            
            // 检查是否为多级编号（如1.1.或2.3.4.）
            // 查看句点前面的文本
            const before = string.slice(0, offset);
            // 查看句点后面的文本（最多10个字符，足够判断是否有更多句点或只有空白）
            const after = string.slice(offset + 1, offset + 11);
            
            // 检查是否为多级编号格式（如1.1.或1.2.3.）
            // 情况1：如果前面已经有数字和句点（如1.1.中的第二个句点）
            if (/\d+\.\d+$/.test(before)) {
              return match;
            }
            
            // 情况2：如果后面紧跟数字和句点（如1.1.中的第一个句点）
            if (/^\s*\d+\./.test(after)) {
              return match;
            }
            
            // 情况3：如果句点是编号的一部分，但后面直接是内容（如"1.直播时间与地点"）
            if (/(\s|^)(\d+|[一二三四五六七八九十]+|[A-Za-z]+|[IVXLCDM]+)$/.test(before) && !/^\s*$/.test(after)) {
              return match;
            }
            
            // 情况4：编号后没有内容，可能是需要换行的情况（如"1.1."单独一行）
            if (/(\s|^)(\d+|[A-Za-z]+|[IVXLCDM]+)(\.\d+)*$/.test(before) && /^\s*$/.test(after.trim())) {
              return `${p1}\n`;
            }
          }
          
          // 其他情况，在标点后追加换行符
          return `${p1}\n`;
        })
        // 合并连续的换行符为一个
        .replace(/\n+/g, '\n')
        .trim();
    } else {
      return '';
    }
  }

  function calculateLength(starttime, endtime) {
    // Validate input to prevent errors
    if (!starttime || !endtime) {
        console.error("Invalid time input", { starttime, endtime });
        return "00:01";
    }

    try {
        // Parse start time
        let startHour = parseInt(starttime.split(':')[0]);
        let startMinutes = parseInt(starttime.split(':')[1].split(' ')[0]);
        let startAMPM = starttime.split(' ')[1];

        if (startAMPM === 'PM' && startHour < 12) startHour += 12;
        if (startAMPM === 'AM' && startHour === 12) startHour = 0; // Midnight case

        // Parse end time
        let endHour = parseInt(endtime.split(':')[0]);
        let endMinutes = parseInt(endtime.split(':')[1].split(' ')[0]);
        let endAMPM = endtime.split(' ')[1];

        if (endAMPM === 'PM' && endHour < 12) endHour += 12;
        if (endAMPM === 'AM' && endHour === 12) endHour = 0; // Noon case

        // Create date objects
        let start = new Date(`1970-01-01T${startHour.toString().padStart(2, '0')}:${startMinutes.toString().padStart(2, '0')}`);
        let end = new Date(`1970-01-01T${endHour.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}`);

        // Calculate duration
        let durationInMinutes = (end - start) / (1000 * 60);
        if (durationInMinutes < 0) {
            durationInMinutes += 24 * 60; // Account for overnight durations
        }

        let hours = Math.floor(durationInMinutes / 60);
        let minutes = Math.floor(durationInMinutes % 60);

        // 如果小时和分钟都为0，则将分钟设置为1
        if (hours === 0 && minutes === 0) {
          minutes = 1;
        }

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    } catch (error) {
        console.error("Error calculating time length", error);
        return "00:01";
    }
  }

  function copyText() {
    // 获取需要复制的文本内容
    // const textToCopy = document.querySelector('.textarea-notedetail').innerText;
    let textToCopy = noteLocal.transcript;
    if (view === 'summary') {
      textToCopy = formattedSummary;
    } else if (view === 'transcript') {
      textToCopy = formattedTranscript;
    } 
  
    // 使用navigator.clipboard.writeText新API复制文本
    navigator.clipboard.writeText(textToCopy).then(() => {
      // 动态创建提示窗口
      showCopyToast();
    }).catch(err => {
      // 处理可能出现的错误
      console.error('Failed to copy text: ', err);
    });
  }
  
  function showCopyToast() {
    // 创建提示元素
    const toast = document.createElement('div');
    toast.innerText = 'Copied to clipboard';
    toast.style.position = 'fixed';
    toast.style.top = '80px';
    toast.style.left = '50%';
    toast.style.transform = 'translateX(-50%)';
    toast.style.backgroundColor = 'rgba(0,0,0,0.7)';
    toast.style.color = 'white';
    toast.style.padding = '10px';
    toast.style.borderRadius = '10px';
    toast.style.zIndex = '99999';
  
    // 将提示元素添加到文档中
    document.body.appendChild(toast);
  
    // 3秒后移除提示元素
    setTimeout(() => {
      document.body.removeChild(toast);
    }, 2000);
  }

  //2024.07.03 edit title
  // 添加一个函数来处理编辑标签的点击事件
  const handleEditTitleClick = (event) => {
    event.stopPropagation(); // 阻止事件冒泡
    setIsEditingTitle(true);
    if (noteHeaderRef.current) {
      const width = noteHeaderRef.current.getBoundingClientRect().width;
      setInputWidth(width*0.75 + 'px'); 
    }
  };
  
  // 添加一个函数来处理输入框的失焦事件
  const handleTitleBlur = () => {
    setTimeout(() => {
      setIsEditingTitle(false);
    }, 2);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if(name === 'polishedText') {
      setFormattedPolishedText(value)
    } else if(name === 'transcript') {
      setFormattedTranscript(value)
      setContent(value);
      contextRef.current.lastContentHash = ''; // 强制更新系统提示
    } else if(name === 'summary') {
      setFormattedSummary(value)
    } else if(name === 'title') {
      setFormattedTitle(value)
    }

    if(!transcriptDataExist || name === "title" || name == 'summary') {
      setNoteLocal(prevState => ({
        ...prevState,
        [name]: value
      }));
      setNoteDetailChanged(true);
    } 
    
    if(transcriptBody && transcriptDataExist) {
      setTranscriptBody(prevState => ({
        ...prevState,
        [name]: value
      }));
      setNoteDetailChanged(true);
    }
  };

  function autoResizeTextarea(textarea) {
    // 先重置高度，以便重新计算
    textarea.style.height = 'auto';
    // 设置高度为内容的实际高度
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  const saveNoteDetailAndClose = async () => {
    // 判断 note 的各项内容是否发生变化
    // console.log('noteLocal:', noteLocal);
    const noteContentChanged = 
      noteLocal.title !== note.title ||
      noteLocal.summary !== note.summary ||
      noteLocal.transcript !== note.transcript ||
      noteLocal.polishedText !== note.polishedText;
  
    // 分支 A：当笔记详情发生变化且没有 transcript 数据，或 tokenUsage 大于 0 时
    if ((noteDetailChanged && !transcriptDataExist && noteContentChanged) || tokenUsage > 0) {
      // 如果存在 transcript 数据且有 transcriptBody，则更新 transcription 数据
      if (noteDetailChanged && transcriptDataExist && transcriptBody) {
        console.log('Call updateTranscriptionData. transcriptBody:', transcriptBody);
        updateTranscriptionData(transcriptBody);
      }
  
      // 根据 GPT 版本和 tokenUsage 计算新的 usage 值
      let usageOfResultAndResponse = 0;
      if (userDataLocal?.GPTVersion === 'GPT-3.5') {
        usageOfResultAndResponse = userDataLocal.Usage.time + tokenUsage / 10000;
      } else if (userDataLocal?.GPTVersion === 'GPT-4o mini') {
        usageOfResultAndResponse = userDataLocal.Usage.time + tokenUsage / 8000;
      } else {
        usageOfResultAndResponse = userDataLocal.Usage.time + tokenUsage / 1000;
      }
  
      // 保留小数点后两位
      if (typeof usageOfResultAndResponse === 'number' && !isNaN(usageOfResultAndResponse)) {
        usageOfResultAndResponse = Math.round(usageOfResultAndResponse * 100) / 100;
      } else {
        console.error('usageOfResultAndResponse is invalid number.');
      }
  
      // 如果 tokenUsage 大于 0，则传递 usage 信息
      if (tokenUsage > 0) {
        const usage = {
          time: usageOfResultAndResponse,
          tokenusage: userDataLocal.Usage.tokenusage + tokenUsage,
        };
        setTokenUsage(0);
        onClose(noteLocal, usage);
      } else {
        onClose(noteLocal);
      }
    } else {
      // 分支 B：否则
      if (noteDetailChanged && transcriptDataExist && transcriptBody) {
        // console.log('Call updateTranscriptionData. transcriptBody:', transcriptBody);
        updateTranscriptionData(transcriptBody);
        onClose(noteLocal);
      } else {
        // 如果 note 的关键字段没有变化，则直接关闭，不传 noteLocal
        if (
          noteLocal.title === note.title &&
          noteLocal.keywords === note.keywords &&
          noteLocal.outline === note.outline
        ) {
          onClose();
        } else {
          onClose(noteLocal);
        }
      }
    }
  }

  //2025.02.14 chatPanel
  // 格式化时间的函数
  const formatTimestamp = (msgTimestamp) => {
    const now = new Date();
    const msgTime = new Date(msgTimestamp);
  
    // 如果时间发生在今日之前，则返回格式化时间
    if (now.toDateString() !== msgTime.toDateString()) {
      return msgTime.toLocaleString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      });
    }
  
    const diffMs = now - msgTime;
    const diffMinutes = diffMs / 60000;
  
    if (diffMinutes < 1) {
      return 'Just Now';
    } else if (diffMinutes < 30) {
      const minutesAgo = Math.floor(diffMinutes);
      return `${minutesAgo} minute${minutesAgo > 1 ? 's' : ''} ago`;
    } else if (diffMinutes < 60) {
      return 'half hour ago';
    } else {
      const diffHours = Math.floor(diffMinutes / 60);
      return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    }
  };

  // 发送消息
   const handleSend = async() => {
    const trimmed = inputValue.trim();
    if((!trimmed && defaultPromptContent === 'Ask Nvoice something...') || isLoading) {
      return;
    }

    setIsLoading(true);
    // 1. 添加用户消息
    let userContent = trimmed;
    if(!trimmed && defaultPromptContent === 'Ask Nvoice sth. e.x: Summarize the timestamps'){
      userContent = defaultUserQuestion.trim();
      inputRef.current.value = userContent;
      setDefaultPromptContent('Ask Nvoice something...');
    }
     
    const newUserMessage = {
      id: Date.now(),
      user: userName,
      avatar: userAvatar,
      content: userContent,
      timestamp: Date.now(),
    };
    setMessages((prev) => [...prev, newUserMessage]);
    // console.log('usercontent:', userContent);

    // 清空输入框
    setInputValue('');
    setMessageChanged(true);
    // 启动流式请求
    await handleStreamResponse(userContent);
  };

  // 终止请求
  const abortRequest = () => {
    if (contextRef.current.controller) {
      contextRef.current.controller.abort();
    }
    setIsLoading(false);
    setIsStreaming(false);
  };

  //2025.04.25 OneClick copy AI response
  const handleCopyDetail = (rawContent) => {
  // 去掉 html、转回换行
  const text = String(rawContent)
    .replace(/<[^>]+>/g, '')
    .replace(/\\n/g, '\n');
  
  // 检测内容的主要语言
  const contentLanguage = detectContentLanguage(text);
  
  // 根据内容语言选择适当的水印
  let appendTags = '\n\n-- by nvoice.ai';
  switch (contentLanguage) {
    case "en":
      appendTags = '\n\n--- Notes generated by nvoice.ai';
      break;
    case "zh-CN":
      appendTags = '\n\n--- 笔记及时间戳由 nvoice.ai 自动生成';
      break;
    case "zh-TW":
      appendTags = '\n\n--- 筆記及時間戳由 nvoice.ai 自動生成';
      break;
    case "ja":
      appendTags = '\n\n--- nvoice.ai によって生成されたノートとタイムスタンプ';
      break;
    case "ko":
      appendTags = '\n\n--- nvoice.ai에서 생성된 메모 및 타임스탬프';
      break;
    case "es":
      appendTags = '\n\n--- Notas y marcas de tiempo generadas por nvoice.ai';
      break;
    case "fr":
      appendTags = '\n\n--- Notes et horodatages générés par nvoice.ai';
      break;
    case "de":
      appendTags = '\n\n--- Von nvoice.ai generierte Notizen und Zeitstempel';
      break;
    default:
      appendTags = '\n\n-- by nvoice.ai';
      break;
  }
  
  navigator.clipboard.writeText(text + appendTags)
    .then(() => {
      console.log('Copied detail successfully.');
      showCopyToast();
    })
    .catch(err => console.error('Copy failed:', err));
};

  // 检测内容的主要语言
const detectContentLanguage = (text) => {
  // 简单的语言检测逻辑
  // 检查中文字符比例
  const chineseChars = text.match(/[\u4e00-\u9fff]/g) || [];
  const chineseRatio = chineseChars.length / text.length;
  
  // 检查日文特有字符
  const japaneseChars = text.match(/[\u3040-\u309F\u30A0-\u30FF]/g) || [];
  const japaneseRatio = japaneseChars.length / text.length;
  
  // 检查韩文特有字符
  const koreanChars = text.match(/[\uAC00-\uD7AF\u1100-\u11FF]/g) || [];
  const koreanRatio = koreanChars.length / text.length;
  
  // 检测西里尔字母（俄语等）
  const cyrillicChars = text.match(/[\u0400-\u04FF]/g) || [];
  const cyrillicRatio = cyrillicChars.length / text.length;
  
  // 检测其他拉丁字母语言特征词
  const spanishWords = /\b(el|la|los|las|y|en|que|es|por|para|con)\b/gi.test(text);
  const frenchWords = /\b(le|la|les|des|et|en|que|qui|est|pour|avec)\b/gi.test(text);
  const germanWords = /\b(der|die|das|und|ist|für|mit|auf|zu|in)\b/gi.test(text);
  
  // 判断主要语言
  if (chineseRatio > 0.1) {
    // 简体和繁体的区分可以通过特定字符判断，这里简化处理
    return text.match(/[\u7B80\u7C21\u8F7B\u79D1\u53F0\u81FA]/) ? "zh-CN" : "zh-TW";
  } else if (japaneseRatio > 0.1) {
    return "ja";
  } else if (koreanRatio > 0.1) {
    return "ko";
  } else if (cyrillicRatio > 0.1) {
    return "ru";
  } else if (spanishWords && (text.includes('ñ') || text.includes('¿') || text.includes('¡'))) {
    return "es";
  } else if (frenchWords && (text.includes('ç') || text.includes('é') || text.includes('è'))) {
    return "fr";
  } else if (germanWords && (text.includes('ß') || text.includes('ü') || text.includes('ä'))) {
    return "de";
  }
  
  // 默认英文
  return "en";
};

  const renderTabContent = () => {
    if (activeTab === 'AI Chat') {
      return (
        <div className="chat-container-detail">
          <div className="chat-messages-detail">
            {messages.length === 0 && (
              <div className="chat-message-detail">
                <img src={nvoiceLogo} alt="avatar" className="avatar-detail" />
                <div className="message-content-detail">
                  <div className="message-user-detail">Nvoice</div>
                  <div className="message-text-detail">
                    Hi, I'm Nvoice, how can I help you today?
                  </div>
                </div>
              </div>
            )}
            {messages.map((msg) => (
              <div
                key={msg.id}
                className={`chat-message-detail ${
                  msg.user === 'Nvoice' ?  'nvoice-message-detail' : 'user-message-detail'
                }`}
              >
                <img src={msg.avatar} alt="avatar" className="avatar-detail" />
                <div className="message-content-detail">
                  <div className="message-user-detail">
                    {msg.user}{' '}
                    <span className="message-time-detail">{formatTimestamp(msg.timestamp)}</span>
                    <button
                      className="copy-detail-btn"
                      onClick={() => handleCopyDetail(msg.content)}
                      style={{
                        marginLeft: '8px',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer'
                      }}
                      title="Copy detail"
                    >
                      <FontAwesomeIcon icon={faCopy} />
                    </button>
                  </div>
                  <div className="message-text-detail">
                    {nl2br(typeof msg.content === 'string' ? msg.content.replace(/\\n/g, "\n").replace(/\*\*/g, '') : '')}
                    </div>
                </div>
              </div>
            ))}
            {isLoading && (
              <div className="typing-indicator">
                Nvoice thingking
                <span className="dots">
                  <span>.</span><span>.</span><span>.</span>
                </span>
              </div>
            )}
            {isStreaming && <div className="message-text-detail">{nl2br(typeof streamingContent === 'string' ? streamingContent.replace(/\\n/g, "\n") : streamingContent)}</div>}
            {/* 自动滚动锚点 */}
            <div ref={messagesEndRef} />
          </div>
          <div className="chat-input-detail">
            <input
              ref={inputRef}
              type="text"
              placeholder={defaultPromptContent}
              value={inputValue}
              disabled={isLoading}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleSend();
              }}
            />
            <Button 
              onClick={isStreaming ? abortRequest : handleSend} 
              className="appstyle-btn notedetail-appstyle-btn"
            >
              <FontAwesomeIcon icon={isStreaming ? faStop : faPaperPlane} className="appstyle-btn-interspace"/>
            </Button>
          </div>
        </div>
      );
    } else if (activeTab === 'Outline') {
      return (
        <div className="placeholder-content-detail">
          This is the Outline tab content.
        </div>
      );
    } else if (activeTab === 'Documents') {
      return (
        <div className="placeholder-content-detail">
          This is the Documents tab content.
        </div>
      );
    }
    return null;
  };
  

  return (
    <div className="popup-background-detail">
      <div className="note-detail-container">
        <div className="note-detail">
          <div className="note-header"  ref={noteHeaderRef} >

            <div className="note-header-title">
              {/* <h2 className="note-title">{note.title.replace(/"/g, '')}</h2> */}

              {/* {!isEditingTitle && 
                  <span style={{fontWeight:'600'}}>
                    {noteLocal.title.replace(/"/g, '')} 
                    <FontAwesomeIcon  
                    icon={faPencilAlt}
                    className="edit-icon"
                    onClick={(event) => handleEditTitleClick(event)}
                    />
                  </span>
                } */}

                {/* {isEditingTitle &&  */}
                  <input
                  type="text"
                  name="title"
                  value={formattedTitle}
                  style={{fontWeight:'600', width: inputWidth}}
                  onClick={handleEditTitleClick}
                  onChange={handleInputChange}
                  placeholder={formattedTitle}
                  readOnly={!isEditingTitle}
                  onBlur={handleTitleBlur} // 当输入框失去焦点时，结束编辑
                  />
                {/* } */}
              {isEditingTitle && 
              <span className="note-edit-done" onClick={handleTitleBlur}>Done</span>}

              <span className="close" onClick={saveNoteDetailAndClose}>&times;</span>
            </div>

            <div className="note-meta">
              <div className='note-meta-inner'>
                <FontAwesomeIcon icon={faCalendar} className="lighter-icon" /><span>{note.date} at {note.starttime.toLowerCase()} - {note.endtime.toLowerCase()} </span>
              </div>
              <div className='note-meta-inner'> 
                <FontAwesomeIcon icon={faClock} className="lighter-icon"  /><span>{calculateLength(note.starttime, note.endtime)}</span>
              </div>
              <button 
              className='note-button note-meta-inner' 
              onClick={copyText}>
                <FontAwesomeIcon icon={faCopy} className="lighter-icon" />Copy {view}
              </button>
            </div>
          </div>

          <div className="summary-transcript-toggle">
              <div
                className={`summary ${view === 'summary' ? 'active' : ''}`}
                onClick={() => setView('summary')}
              >
                Summary
              </div>
              <div
                className={`transcript ${view === 'transcript' ? 'active' : ''}`}
                onClick={() => setView('transcript')}
              >
                Transcript
              </div>
          </div>

          <div className="note-detail-body">

            {view === 'summary' && (
              <div className="note-body-transcript">
                <textarea
                  ref={textareaRefOFSummary}
                  name="summary"  
                  value={formattedSummary}
                  className='textarea-notedetail'
                  onChange={handleInputChange}
                  onClick={handleEditTitleClick}
                  onBlur={handleTitleBlur} 
                />
              </div>
            )}

            {/* {view === 'transcript' && audioUrl && (
              <div> 
                <audio controls style={{ width: '100%', height: '30px'}}>
                  <source src= {audioUrl} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </div>)}     */}
            
            {view === 'transcript' && (
              <div className="note-body-transcript">
                <textarea
                  ref={textareaRefOFTranscript}
                  name="transcript"  
                  value={formattedTranscript}
                  className='textarea-notedetail'
                  onChange={handleInputChange}
                  onClick={handleEditTitleClick}
                  onBlur={handleTitleBlur} 
                />
              </div>
            )}

            <div className='note-separator'></div>

            {/* <div className="action-item" onClick={() => { }}>
              + Add action item
            </div> */}


            {/* {view === 'summary' && (
              <div className="notedetail-outline">
                <h3 className='h3-notedetail'>Outline</h3>
                {formattedOutline.replace(/(?!^)(\d+\.)/g, '\n$1').split('\n').map((item, key) => {
                  return <span key={key}>{item}<br/></span>
                })}
              </div>
            )} */}

            {view === 'summary' && (
              <div className="notedetail-outline">
                <h3 className='h3-notedetail'>Outline</h3>
                {formattedOutline.split('\n').map((item, key) => {
                  if (!item.trim()) return null;
                  const trimmedItem = item.trim();
                  let level = 0;

                  // 多级数字编号 (1.1, 1.1.1)
                  if (/^\d+(\.\d+)+/.test(trimmedItem)) {
                    const dotsCount = (trimmedItem.match(/\./g) || []).length;
                    level = Math.min(dotsCount, 3);
                    level = flagOfTopic ? level + 1 : level;
                  }
                  // 中文编号
                  else if (/^[一二三四五六七八九十]+、/.test(trimmedItem)) {
                    level = 0;
                    flagOfTopic = true;
                  }
                  // 中文编号
                  else if (/^[一二三四五六七八九十]+./.test(trimmedItem)) {
                    level = 0;
                    flagOfTopic = true;
                  }
                  // 罗马数字
                  else if (/^[IVX]+\./.test(trimmedItem)) {
                    level = 0;
                    flagOfTopic = true;
                  }
                  // 单级数字编号 (1.)
                  else if (/^\d+\./.test(trimmedItem)) {
                    level = flagOfTopic ? 1 : 0;
                  }
                  // 字母编号 (a.)
                  else if (/^[a-z]\./.test(trimmedItem)) {
                    level = flagOfTopic ? 3 : 2;
                  }
                  // 无符号编号 (1 )
                  else if (/^\d+\s/.test(trimmedItem)) {
                    level = flagOfTopic ? 1 : 0;
                  }
                  // 项目符号
                  else if (/^[•\-*]\s/.test(trimmedItem)) {
                    level = flagOfTopic ? 2 : 1;
                  }
                  // 标题
                  else if (key === 0 || /^[A-Z].*:$/.test(trimmedItem)) {
                    level = flagOfTopic ? 1 : 0;
                  }
                  // 次级标题（冒号结尾）
                  else if (/^[A-Za-z][\w\s]+:/.test(trimmedItem)) {
                    level = flagOfTopic ? 2 : 1;
                  }

                  return (
                    <span key={key} style={{
                      paddingLeft: `${level * 20}px`,
                      display: 'block',
                      marginBottom: level === 0 ? '8px' : '4px'
                    }}>
                      {trimmedItem}
                    </span>
                  );
                })}
              </div>
            )}

            {view === 'transcript' && noteLocal.VIPLevel > 0 && formattedPolishedText !== '' && (
              <div className="note-body-transcript">
                <h3 className='h3-transcript'>Polished Text:</h3>
                <textarea
                  ref={textareaRefOFPolishedText}
                  name="polishedText"  
                  value={formattedPolishedText}
                  className='textarea-notedetail'
                  onChange={handleInputChange}
                  onClick={handleEditTitleClick}
                  onBlur={handleTitleBlur} 
                  style={{formSizing:'normal'}}
                />
              </div>
            )}

            {view === 'transcript' && noteLocal.VIPLevel > 0 && formattedPolishedText !== '' && (
              <div className='note-separator'></div>)}

            {view === 'transcript' && noteLocal.VIPLevel > 0 && formattedGptresponse !== '' &&  (
              <div className="note-body-transcript">
                <h3 className='h3-transcript'>Nvoice response: </h3>
                {formattedGptresponse.replace(/([.!?;。！？；"])\s*/g, '$1\n').split('\n').map((item, key, array) => {
                  return <span key={key}>{item}{key < array.length - 1 && <br/>}</span>
                })}
              </div>)}

            {view === 'transcript' && noteLocal.VIPLevel > 0 && noteLocal.gptresponse !== '' && (
              <div className='note-separator'></div>)}

            {view === 'transcript' && (
              <div className="notedetail-keywords">
                <h3 className='h3-transcript'>Keywords</h3>
                {formattedKeywords}
              </div>)}

          </div>

          {view === 'transcript' && audioUrl && !videoURL && (
            // <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}> 
            <div className='note-footer'> 
              <audio controls style={{ width: '100%', height: '30px' }}>
                <source src= {audioUrl} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            </div>)}    

          {view === 'transcript' && videoURL && showPlayer && (
            <Draggable onStart={() => setShowHint(false)}>
              <div className="draggable-video-player" style={{
                position: 'absolute',
                top: '150px',
                right: '10px',
                zIndex: 1000,
                backgroundColor: 'white',
                padding: '10px',
                borderRadius: '8px',
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'
              }}>
                <button 
                  onClick={() => setShowPlayer(false)} 
                  style={{
                    position: 'absolute',
                    top: '5px',
                    right: '5px',
                    background: 'transparent',
                    border: 'none',
                    fontSize: '16px',
                    cursor: 'pointer'
                  }}
                >
                  &times;
                </button>
                {/* {showHint && ( */}
                <p style={{ margin: '0 0 10px 0', fontSize: '12px', color: '#361700', fontWeight: '700' }}>
                  You can drag the window anywhere.
                </p>
                {/* )} */}
                <ReactPlayer 
                  config={{
                    youtube: {
                      playerVars: {
                        origin: window.location.origin
                      }
                    }
                  }}
                  onReady={() => console.log('Player is ready')}
                  onPlay={() => setShowHint(false)}
                  onError={(e) => console.error('Player error:', e)}
                  url={videoURL}
                  controls
                  playing={false}
                  width="300px"
                  height="200px"
                />
              </div>
            </Draggable>
          )}
        </div>

        <div className="aichat-popup-detail">
          <div className="chat-panel-detail">
            <div className="tabs-detail">
              {['AI Chat'].map((tab) => (  //['AI Chat', 'Outline', 'Documents']
                <div
                  key={tab}
                  className={`tab-item-detail ${activeTab === tab ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </div>
              ))}
            </div>
            <div className="tab-content-detail">{renderTabContent()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notedetail;
